/** @format */

import React from "react";
import "../Style/spinner.css";

export default function LoadingSpinner() {
  return (
    <div className='spinner-container'>
      <div className='spinner'></div>
    </div>
  );
}
